<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <ng-container>
        <div style="padding: 15px; margin: 5px;width: 94%;">
            <div class="main-heading">
                <h1>Product DashBoard</h1>
            </div>

            <p-table [value]="productsData?.all_roa_list" [tableStyle]="{'min-width': '60rem'}" [paginator]="true"
                [rows]="10" [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [rowsPerPageOptions]="[10, 20, 50]" [loading]="proloading">
                <ng-template pTemplate="header">
                    <tr>
                        <th>ROA</th>
                        <th>QA Count</th>
                        <th>Live Count</th>
                        <th>Not in Live</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                    <tr>
                        <td>{{ rowData }}</td>
                        <td>{{ productsData.total_count[rowData]?.Qa || 0 }}</td>
                        <td>{{ productsData.total_count[rowData]?.Live || 0 }}</td>
                        <td>{{ (productsData.total_count[rowData]?.Qa || 0) - (productsData.total_count[rowData]?.Live
                            || 0) }}</td>
                    </tr>
                </ng-template>
            </p-table>

            <div class="OptionFilter">
                <div class="dropdown" style="margin: 10px 0px;">
                    <p-dropdown autoWidth="false" [options]="roaDropdownOptions" [(ngModel)]="selectedRoa"
                        (onChange)="showRoaData()" placeholder="Select ROA">
                    </p-dropdown>
                </div>

                <div class="dropdown" style="margin: 10px 0px;">
                    <p-dropdown autoWidth="false" [options]="typeDropdownOptions" [(ngModel)]="selectedType"
                        (onChange)="showRoaData()" placeholder="Select Type">
                    </p-dropdown>
                </div>
            </div>

            <p-table #dt1 [value]="selectedRoaData" [tableStyle]="{'min-width': '60rem'}" [paginator]="true" [rows]="10"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [rowsPerPageOptions]="[10, 20, 50]" [loading]="loading" [(selection)]="selectedProducts"
                [globalFilterFields]="['NDA Number', 'Brand Name', 'Active Ingredient', 'Dosage forms', 'Route of Administration', 'Last Pushed Date']">
                <ng-template pTemplate="caption">
                    <div class="flex" style="display: flex; justify-content: flex-end;">
                        <button *ngIf="isLiveSelected" type="button" pButton label="Remove Products from Live"
                            class="p-button-danger" [disabled]="!selectedProducts || selectedProducts.length === 0"
                            (click)="getRemoveProductsData()"></button>
                        <span class="p-input-icon-left ml-auto">
                            <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                                placeholder="Search keyword" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th>
                            <span style="margin-right: 4px;">Remove</span>
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th>NDA</th>
                        <th>Brand</th>
                        <th>Active</th>
                        <th>Dosage</th>
                        <th>ROA</th>
                        <th>Last Pushed To Live</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                        </td>
                        <td>{{ rowData['NDA Number'] }}</td>
                        <td>{{ rowData['Brand Name'] }}</td>
                        <td>{{ rowData['Active Ingredient'] }}</td>
                        <td>{{ rowData['Dosage forms'] }}</td>
                        <td>{{ rowData['Route of Administration'] }}</td>
                        <td>{{ rowData['Last Pushed Date'] | date:'dd-MM-yyyy HH:mm:ss' }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="6" style="text-align: center;">
                            NO DATA FOUND
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <p-dialog header="Confirm Remove" [(visible)]="displayBulkRemoveDialog" [modal]="true" [closable]="false">
            <p>Are you sure you want to remove selected records from live?</p>

            <div class="p-field custom-comment-box">
                <label for="comment" class="comment-label">Comment:</label>
                <textarea id="comment" pInputTextarea [(ngModel)]="removalComment" rows="2" cols="40"
                    required></textarea>
            </div>

            <div *ngIf="emailMessage" [innerHTML]="emailMessage"></div>

            <p-footer>
                <button type="button" pButton icon="pi pi-times" label="No"
                    (click)="displayBulkRemoveDialog = false"></button>
                <button type="button" pButton icon="pi pi-check" label="Yes" class="p-button-danger"
                    [disabled]="!removalComment || removalComment.trim() === ''"
                    (click)="removeSelectedProducts()"></button>
            </p-footer>
        </p-dialog>

    </ng-container>
</div>